module.exports = __webpack_public_path__ + "static/img/8.8a5b63a1.png";